import React from 'react';
import '../../styles/Educacion.css';

export default function Educacion() {
    return (
        <div id='educacion' className="educacion__div--container">
            <div className="educacion__div--seccion-educacion">
                <h2 className="educacion__h2--educacion">Educación</h2>
                <ul className="educacion__ul--lista">
                    <li>
                        Universidad Pontificia Bolivariana: Mision TIC 2022
                    </li>
                    <li>
                        Diferentes cursos en plataformas como Udemy y Platzi
                    </li>
                </ul>
            </div>
        </div>
    )
}
